module.exports = __webpack_public_path__ + "img/zhendong2.gif";